import {FastForward, Pause} from "@mui/icons-material";
import * as React from "react";
import {ONGOING, PAUSE} from "../../Utils/constants";

const PauseCaseIcon = ({person}) => {
    return (
        <>
            {
                person.hasOwnProperty("special_case_type") && person.special_case_type === PAUSE &&
                    <Pause sx={{color: "purple"}} style={{fontSize: '20px'}}/>

            }
            {
                person?.hasOwnProperty("special_case_type") && person.special_case_type === ONGOING &&
                    <FastForward sx={{color: "purple"}} style={{fontSize: '20px'}}/>
            }
        </>
    )
}

export default PauseCaseIcon;